import Image from 'next/image';

import { getCloudflareImageLink } from '@lib/image/getters';

interface FeaturedImageProps {
  className?: string;
  src: string;
  caption: string | null;
}
export default function FeaturedImage({ className, src, caption }: FeaturedImageProps) {
  return (
    <div className={className}>
      <Image
        className="mb-2 h-auto w-full rounded-md"
        src={
          getCloudflareImageLink(src) ||
          'https://cdn-trans.info/uploads/2017/09/86d06cfc167f8e3f01657fde7eb-1024x684.jpg'
        }
        loading="lazy"
        alt=""
        width={735}
        height={500}
      />
      {caption && <p className="text-xs text-gray-600 lg:text-sm">{caption}</p>}
    </div>
  );
}
